import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from '../i18n/translations';
type LanguageContextType = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (path: string) => any;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const t = (path: string) => {
    const keys = path.split('.');
    let current: any = translations[lang];
    for (const key of keys) {
      if (current[key] === undefined) {
        console.warn(`Translation missing for key: ${path} in lang: ${lang}`);
        return path;
      }
      current = current[key];
    }
    return current;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-407">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}